import { Modal, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

function ModalLogout({ show, onHide }) {
  const { t } = useTranslation();

  const handleLogout = () => {
    localStorage.removeItem("user");
    window.location.reload();
  };

  return (
    <Modal backdrop="static" centered size="md" show={show} onHide={onHide}>
      <Modal.Header closeVariant="white" closeButton>
        <Modal.Title>{t("Sair da aplicação")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{t("Deseja mesmo sair da aplicação?")}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t("Fechar")}
        </Button>
        <Button variant="danger" onClick={handleLogout}>
          {t("Sair")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

ModalLogout.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default ModalLogout;
